import { render, staticRenderFns } from "./Descargas.vue?vue&type=template&id=a8d01782&"
import script from "./Descargas.vue?vue&type=script&lang=js&"
export * from "./Descargas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports